import React, {Component, ReactElement, ReactNode} from 'react'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {CASH_PAYMENT_STATUS, MESSAGE_TYPE, PAYMENT_TYPE, SELECT_USER_TYPE} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {getYearAfterNextDateFac, getYearDateFac, nullToBlank} from '../../common/util/Natutil'
import PPNumericField from '../../../components/shared/forms/PPNumericField'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import styled from 'styled-components'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import {LeftRowFlexContainer, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import FacilitiesRepository, {FacilitiesForPagination} from '../../../components/facilities/FacilitiesRepository'
import {SortOrder} from '../../../components/shared/SortOrder'
import FacilityForAdmin from '../../../components/facilities/FacilityForAdmin'
import PPErrorDisplayButton from '../../../components/shared/forms/PPErrorDisplayButton'
import NatResidentUserSelectionComponent from '../common/admin/NatResidentUserSelectionComponent'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import {ResidentUserInfo} from '../roomToResident/repository/NatGetRoomToResident'
import {
    SelectedModalInfoItemLabel,
    SelectedModalInfoItemValue,
    SelectedModalInfoItemValueCondominium,
} from '../adminUser/NatAdminAdminUserRegisterPage'
import {HKConstants} from '../../../HKConstants'
import {ConditionTableFixed} from '../../../styledComponents/adminPage/ConditionTable'
import {NatPostAdditionalBilling} from './repository/NatPostAdditionalBilling'
import NatFacilityReserveRepo from './repository/NatFacilityReserveRepo'
import {formatForDateInput} from '../../../formatters/formatDate'
import {NatGetAdditionalBilling} from './repository/NatGetAdditionalBilling'
import {NatPutAdditionalBillingParams} from './repository/NatPutAdditionalBilling'
import NatFacilityRepo from '../facility/repository/NatFacilityRepo'
import {getDisplayUserNameForManagement} from '../../../components/reservations/admin/AdminReserveHelper'
import moment from 'moment'
import {Location} from 'react-router-dom'

import {TableBody, TableRow, TableCell, InputAdornment} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'

const SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface Props {
    facilityRepo: NatFacilityRepo
    facilitiesRepo: FacilitiesRepository
    facilityReserveRepo: NatFacilityReserveRepo
    RidgeRepo: NatRidgeRepo
    RoomToResidentRepo: NatRoomToResidentRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    facilityReserveId: string
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    reserveTitle: string
    facilityId: string
    facilities: FacilityForAdmin[]
    reserveStartDate: string
    reserveStartDateMin: string
    reserveStartDateMax: string
    dialogOpenSelectResidentUser: boolean
    userId: string
    userRidgeCd: string
    userRoomNumber: string
    userRidgeName: string
    userName: string
    adminUserName: string
    selectedCondominiumCd: string
    facilityUseCharge: string
    paymentMethod: string
    cashPaymentStatus: string
    registerButtonDisabled: boolean
    isLoadCompleted: boolean
    version: number
}

type inputOrSelectRequireState =
    'reserveTitle'
    | 'reserveStartDate'
    | 'userId'
    | 'facilityUseCharge'
    | 'paymentMethod'
    | 'cashPaymentStatus'

class NatAdminAdditionalBillingEditPage extends Component<Props & AdminPagePropsSet, States> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const selectedCondominiumCd: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(SELECTED_CONDOMINIUM_CD)

        this.state = {
            reserveTitle: '',
            facilityId: '',
            facilities: [],
            reserveStartDate: '',
            reserveStartDateMin: '',
            reserveStartDateMax: '',
            dialogOpenSelectResidentUser: false,
            userId: '',
            userRidgeCd: '',
            userRoomNumber: '',
            userRidgeName: '',
            userName: '',
            adminUserName: '',
            selectedCondominiumCd: String(selectedCondominiumCd),
            facilityUseCharge: '',
            paymentMethod: PAYMENT_TYPE.ADMIN_TRANSFER_ACCOUNT.value,
            cashPaymentStatus: CASH_PAYMENT_STATUS.YET_PAID.value,
            registerButtonDisabled: false,
            isLoadCompleted: false,
            version: 0,
        }

        this.handleOpenResidentUserSelectionDialog = this.handleOpenResidentUserSelectionDialog.bind(this)
        this.closeSelectResidentUserDiaLog = this.closeSelectResidentUserDiaLog.bind(this)
        this.setSelectedResidentUserInfo = this.setSelectedResidentUserInfo.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.onChangePaymentMethod = this.onChangePaymentMethod.bind(this)
        this.onChangeFacility = this.onChangeFacility.bind(this)
        this.onChangeReserveTitle = this.onChangeReserveTitle.bind(this)
        this.onChangeReserveStartDate = this.onChangeReserveStartDate.bind(this)
        this.onChangeFacilityUseCharge = this.onChangeFacilityUseCharge.bind(this)
        this.onChangeCashPaymentStatus = this.onChangeCashPaymentStatus.bind(this)
        this.getfacilitiesList = this.getfacilitiesList.bind(this)
        this.registerButton = this.registerButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        const sortOrders: SortOrder[] = [
            new SortOrder('updateDatetime', 'desc'),
        ]

        try {
            // 施設一覧取得
            const facilities: Nullable<FacilitiesForPagination> = await this.props.asyncCallFunction(
                this.props.facilityRepo.getNatFacilitiesForAdmin.bind(
                    this.props.facilityRepo,
                    this.state.selectedCondominiumCd,
                    null,
                    sortOrders,
                    undefined,
                ),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (facilities && facilities.contents) {
                this.setState({
                    facilities: facilities.contents.filter(facility => facility.releaseSetting),
                })
            }

            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime && currentDateTime.details) {
                this.setState({
                    reserveStartDateMin: getYearDateFac(),
                    reserveStartDateMax: getYearAfterNextDateFac(currentDateTime.details.currentDateTime),
                })
            }

            const additionalBilling: Nullable<NatGetAdditionalBilling> = await this.props.asyncCallFunction(
                this.props.facilityReserveRepo.getAdditionalBilling.bind(
                    this.props.facilityReserveRepo, this.props.facilityReserveId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (additionalBilling && additionalBilling.details) {
                this.setState({
                    reserveTitle: additionalBilling.details.reserveTitle,
                    facilityId: String(additionalBilling.details.facilityId),
                    reserveStartDate: formatForDateInput(additionalBilling.details.reserveStartDatetime),
                    userId: additionalBilling.details.userId,
                    userRidgeCd: additionalBilling.details.userRidgeCd,
                    userRoomNumber: additionalBilling.details.userRoomNumber,
                    userRidgeName: additionalBilling.details.userRidgeName,
                    userName: `${nullToBlank(additionalBilling.details.userFamilyName)} ${nullToBlank(additionalBilling.details.userFirstName)}`,
                    adminUserName: nullToBlank(additionalBilling.details.adminFamilyName) + ' '
                        + nullToBlank(additionalBilling.details.adminFirstName),
                    facilityUseCharge: String(additionalBilling.details.facilityUseCharge),
                    paymentMethod: additionalBilling.details.paymentMethod,
                    cashPaymentStatus: additionalBilling.details.cashPaymentStatus,
                    version: additionalBilling.details.version,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    onChangePaymentMethod(event: SelectChangeEvent<unknown>): void {
        this.setState({
            paymentMethod: event.target.value as string,
        })
        this.setRegisterButtonDisabledState('paymentMethod', event.target.value as string)

    }

    onChangeFacility(event: SelectChangeEvent<unknown>): void {
        this.setState({facilityId: event.target.value as string})

    }

    onChangeReserveTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({reserveTitle: event.target.value})
        this.setRegisterButtonDisabledState('reserveTitle', event.target.value)

    }

    onChangeReserveStartDate(date: Nullable<Date>): void {
        this.setState({
            reserveStartDate: date !== null ? formatForDateInput(date.toString()) : '',
            userId: '',
            userRidgeCd: '',
            userRoomNumber: '',
            userRidgeName: '',
            userName: '',
            adminUserName: '',
            registerButtonDisabled: true,
        })
    }

    onChangeFacilityUseCharge(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({facilityUseCharge: event.target.value})
        this.setRegisterButtonDisabledState('facilityUseCharge', event.target.value)

    }

    onChangeCashPaymentStatus(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({cashPaymentStatus: event.target.value})
        this.setRegisterButtonDisabledState('cashPaymentStatus', event.target.value)
    }

    // 登録ボタンの表示・非表示制御
    setRegisterButtonDisabledState(
        inputOrSelectStateKey: inputOrSelectRequireState,
        inputOrSelectStateValue: string,
    ): void {
        const inputOrSelectData: { [key: string]: string; } = {}
        inputOrSelectData.reserveTitle = this.state.reserveTitle
        inputOrSelectData.reserveStartDate = this.state.reserveStartDate
        inputOrSelectData.userId = this.state.userId
        inputOrSelectData.facilityUseCharge = this.state.facilityUseCharge
        inputOrSelectData.paymentMethod = this.state.paymentMethod
        inputOrSelectData.cashPaymentStatus = this.state.cashPaymentStatus
        let registerButtonDisabled: boolean = this.state.registerButtonDisabled

        // パラメータで上書き
        inputOrSelectData[inputOrSelectStateKey] = inputOrSelectStateValue

        if (inputOrSelectData.paymentMethod === PAYMENT_TYPE.CASH.value) {
            registerButtonDisabled = !(inputOrSelectData.reserveTitle &&
                inputOrSelectData.reserveStartDate &&
                inputOrSelectData.userId &&
                inputOrSelectData.facilityUseCharge &&
                inputOrSelectData.paymentMethod &&
                inputOrSelectData.cashPaymentStatus)
        } else {
            registerButtonDisabled = !(inputOrSelectData.reserveTitle &&
                inputOrSelectData.reserveStartDate &&
                inputOrSelectData.userId &&
                inputOrSelectData.facilityUseCharge &&
                inputOrSelectData.paymentMethod)
        }

        this.setState({registerButtonDisabled: registerButtonDisabled})
    }


    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        try {
            const request: NatPutAdditionalBillingParams = {
                facilityReserveId: this.props.facilityReserveId,
                reserveTitle: this.state.reserveTitle,
                facilityId: this.state.facilityId,
                reserveStartDate: this.state.reserveStartDate,
                userId: this.state.userId,
                userRidgeCd: this.state.userRidgeCd,
                userRoomNumber: this.state.userRoomNumber,
                facilityUseCharge: this.state.facilityUseCharge,
                paymentMethod: this.state.paymentMethod,
                version: this.state.version,
            }
            if (request.paymentMethod === PAYMENT_TYPE.CASH.value) {
                request.cashPaymentStatus = this.state.cashPaymentStatus
            }
            const ret: Nullable<NatPostAdditionalBilling> =
                await this.props.asyncCallFunction(
                    this.props.facilityReserveRepo.putUpdateAdditionalBilling.bind(
                        this.props.facilityReserveRepo, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('追加課金')},
                )
            if (ret && ret.requestError === null) {
                this.props.navigate(
                    `/admin/additionalBilling/${this.props.facilityReserveId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0005.toString('追加課金', this.state.reserveTitle),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    getPaymentMethodList(): OptionProps[] {
        let paymentTypes: OptionProps[]

        paymentTypes = PAYMENT_TYPE.values().map((paymentType) => {
            return ({
                label: `${paymentType.label}`,
                value: `${paymentType.value}`,
            })
        })

        return paymentTypes
    }

    getfacilitiesList(): OptionProps[] {
        const facilities: OptionProps[] = this.state.facilities.map((item) => {
            return ({
                label: `${item.facilityName}`,
                value: `${item.facilityId}`,
            })
        })

        return [{
            label: '',
            value: '',
        }, ...facilities]
    }

    getCashPaymentStatusRadioGroupData(): PPRadioItemProp[] {
        const cashPaymentStatusData: PPRadioItemProp[] = []
        CASH_PAYMENT_STATUS.values().map((cashPaymentStatus) => (
            cashPaymentStatusData.push(
                {
                    label: cashPaymentStatus.label,
                    value: cashPaymentStatus.value,
                    radioProps: {
                        checked: cashPaymentStatus.value === this.state.cashPaymentStatus,
                        onChange: this.onChangeCashPaymentStatus,
                    },
                },
            )
        ))
        return cashPaymentStatusData
    }

    async registerButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString(this.state.reserveTitle),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    handleOpenResidentUserSelectionDialog(): void {
        this.setState({
            dialogOpenSelectResidentUser: true,
        })
    }

    closeSelectResidentUserDiaLog(): void {
        this.setState({dialogOpenSelectResidentUser: false})
    }

    async setSelectedResidentUserInfo(selectedResidentUserInfo: ResidentUserInfo): Promise<void> {
        const displayUserNameForManagement = getDisplayUserNameForManagement(selectedResidentUserInfo)

        this.setState({
            userId: selectedResidentUserInfo.sutekiNetId,
            userRidgeCd: selectedResidentUserInfo.ridgeCd,
            userRoomNumber: selectedResidentUserInfo.roomNumber,
            userRidgeName: selectedResidentUserInfo.ridgeName,
            userName: `${nullToBlank(selectedResidentUserInfo.familyName)} ${nullToBlank(selectedResidentUserInfo.firstName)}`,
            adminUserName: displayUserNameForManagement,
            dialogOpenSelectResidentUser: false,
        })
        this.setRegisterButtonDisabledState('userId', selectedResidentUserInfo.sutekiNetId)
    }

    renderSelectedResidentUserInfo(): ReactNode {
        if (this.state.userId === '') {
            return ''
        }

        return (
            <>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>部屋番号</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValue>
                        {this.state.userRidgeName} {this.state.userRoomNumber}
                    </SelectedModalInfoItemValue>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {this.state.userName}
                    </SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>管理者確認用氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {this.state.adminUserName}</SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
            </>
        )
    }

    renderEventFormTable(): ReactNode {
        return (
            <>
                <ConditionTableFixed>
                    <colgroup>
                        <col width={'15%'}/>
                        <col width={'15%'}/>
                        <col width={'15%'}/>
                        <col width={'20%'}/>
                        <col width={'15%'}/>
                        <col width={'10%'}/>
                    </colgroup>
                    <StyledTableCaption>追加課金情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName required>タイトル</TableRowName>
                            <TableCell colSpan={5}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 30,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.reserveTitle}
                                    onChange={this.onChangeReserveTitle}
                                    eventKeys={['reserveTitle']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>施設名</TableRowName>
                            <TableCell colSpan={5}>
                                <PPSelect
                                    data={this.getfacilitiesList()}
                                    onChange={this.onChangeFacility}
                                    eventKeys={['facilityId']}
                                    eventEmitter={this.props.eventEmitter}
                                    value={this.state.facilityId}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>利用日</TableRowName>
                            <TableCell colSpan={5}>
                                <LeftRowFlexContainer>
                                    <TermWrapper style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                        <PPDatePicker
                                            onChangeDate={this.onChangeReserveStartDate}
                                            value={(this.state.reserveStartDate !== '') ?
                                                new Date(this.state.reserveStartDate) : null
                                            }
                                            minDate={(this.state.reserveStartDateMin !== '') ?
                                                new Date(this.state.reserveStartDateMin) : null
                                            }
                                            maxDate={(this.state.reserveStartDateMax !== '') ?
                                                new Date(this.state.reserveStartDateMax) : null
                                            }
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={['reserveStartDate']}
                                        />
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>ユーザ</TableRowName>
                            <TableCell colSpan={5}>
                                <RowFlexContainer>
                                    <SelectedFlexWrapper>
                                        <PPErrorDisplayButton
                                            component={'span'}
                                            disabled={!this.state.reserveStartDate}
                                            size={'small'}
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={['userId']}
                                            onClick={this.handleOpenResidentUserSelectionDialog}
                                            clearError={true}
                                        >
                                            選択する
                                        </PPErrorDisplayButton>
                                    </SelectedFlexWrapper>
                                    {this.renderSelectedResidentUserInfo()}
                                </RowFlexContainer>
                            </TableCell>
                        </TableRow>
                        {this.state.dialogOpenSelectResidentUser &&
                            <NatResidentUserSelectionComponent
                                roomToResidentRepo={this.props.RoomToResidentRepo}
                                ridgeRepo={this.props.RidgeRepo}
                                selectUserType={SELECT_USER_TYPE.USER.value}
                                closeSelectResidentUserDiaLog={this.closeSelectResidentUserDiaLog}
                                setSelectedResidentUserInfo={this.setSelectedResidentUserInfo}
                                selectedCondominiumCd={this.state.selectedCondominiumCd}
                                invalidUserSelectFlag={true}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                                validPeriodCriteriaDate={moment(this.state.reserveStartDate)}
                            />
                        }
                        <TableRow>
                            <TableRowName required>金額</TableRowName>
                            <TableCell colSpan={5}>
                                <label>
                                    <PPNumericField
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                max: HKConstants.VMN.FAC.MAX_PRICE,
                                            },
                                            value: this.state.facilityUseCharge,
                                            endAdornment: <InputAdornment position="end">円</InputAdornment>,
                                        }}
                                        required
                                        onChange={this.onChangeFacilityUseCharge}
                                        eventKeys={['facilityUseCharge']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </label>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>支払方法</TableRowName>
                            <TableCell colSpan={(this.state.paymentMethod === PAYMENT_TYPE.CASH.value) ? 2 : 5}>
                                <PPSelect
                                    autoFocus
                                    data={this.getPaymentMethodList()}
                                    onChange={this.onChangePaymentMethod}
                                    eventKeys={['paymentMethod']}
                                    eventEmitter={this.props.eventEmitter}
                                    value={this.state.paymentMethod}
                                />
                            </TableCell>
                            {this.state.paymentMethod === PAYMENT_TYPE.CASH.value &&
                                <>
                                    <TableRowName required>現金支払ステータス</TableRowName>
                                    <TableCell colSpan={2}>
                                        <PPRadioGroup
                                            row
                                            data={this.getCashPaymentStatusRadioGroupData()}
                                            eventKeys={['cashPaymentStatus']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </TableCell>
                                </>
                            }
                        </TableRow>
                    </TableBody>
                </ConditionTableFixed>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.state.registerButtonDisabled}
                        onClick={this.registerButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/additionalBilling/${this.props.facilityReserveId}`,
                        )}
                    >
                        追加課金詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderEventFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-items: center;
  align-items: center;
  max-width: 35%;
`

const SelectedFlexWrapper = styled.div`
  display: flex;
  padding-right: 15px;
  flex: 1 1 0%;
  align-items: center;
`

const SelectedFlexWrapperWide = styled(SelectedFlexWrapper)`
  flex-grow: 2;
`

export default createAdminPage(NatAdminAdditionalBillingEditPage)
